interface FieldErrorProps {
  errors?: string[];
}

export function FieldError({ errors }: FieldErrorProps) {
  if (!errors || errors.length === 0) return null;
  return (
    <div className="mt-1.5 ml-1 space-y-0.5">
      {errors.map((msg, i) => (
        <p key={i} className="text-[11px] font-bold text-rose-500">
          {msg}
        </p>
      ))}
    </div>
  );
}
